import { useEffect, useMemo } from "react";
import { useRecoilState } from "recoil";
import { IpLocation } from "@/models/user";
import { Button, Input, message, Modal, Descriptions, Spin } from "antd";
import { useMutation } from "react-query";
import axios from "axios";
import validator from "validator";

export default function CustomIpLocation() {
  // Ip归属地
  const [ipLocation, setIpLocation] = useRecoilState(IpLocation);
  // 配置项
  const items = useMemo(() => ipLocation?.data ? [
    {
      label: 'IP',
      key: 'ip',
      children: ipLocation?.data?.ip,
    },
    {
      label: '国家/地区',
      key: 'country',
      children: ipLocation?.data?.country?.name,
    },
    {
      label: '国家/地区简码',
      key: 'country_code',
      children: ipLocation?.data?.country?.code,
    },
    {
      label: '省份',
      key: 'prov',
      children: ipLocation?.data?.regions?.[0],
    },
    {
      label: '城市',
      key: 'city',
      children: ipLocation?.data?.regions?.[1],
    },
    {
      label: '区县',
      key: 'area',
      children: ipLocation?.data?.regions?.[2],
    },
    // {
    //   label: '区域划分',
    //   key: 'big_area',
    //   children: ipLocation?.data?.data?.big_area,
    // },
    {
      label: '运营商',
      key: 'isp',
      children: ipLocation?.data?.as?.info,
    },
    {
      label: '类型',
      key: 'type',
      children: ipLocation?.data?.type,
    },
  ] : [], [ipLocation]);

  // 处理搜索
  const handleSearch = useMutation(async () => {
    // 解构
    const { ip } = ipLocation;
    if (!ip) {
      message.info("请输入Ip")
      return false
    }
    if (!validator.isIP(ip)) {
      message.info("请输入正确的Ip");
      return false;
    }
    const res: any = await axios.get(`https://ipapi.xxlb.org/?ip=${ip}`);
    res?.status === 200 ? setIpLocation({ ...ipLocation, data: res?.data }) : message.info("请稍后重试");
  });

  // 处理初始化
  const handleInit = useMutation(async () => {
    // 解构
    const { ip } = ipLocation;
    ip && handleSearch.mutate();
  });

  // 监听
  useEffect(() => {
    ipLocation?.visible && handleInit.mutate();
  }, [ipLocation?.visible]);

  return (
    <div className="">
      <Modal width="80vw" title="Ip归属地" footer={null} open={ipLocation?.visible} onCancel={() => setIpLocation({ visible: false, ip: '', data: null })} style={{ minWidth: '720px' }}>
        <div className="mt-3">
          <div className="flex items-center">
            <div className="flex items-center">
              <Input placeholder="Ip" value={ipLocation?.ip} onInput={(e: any) => setIpLocation({ ...ipLocation, ip: e.target.value, data: null })} allowClear onClear={() => setIpLocation({ ...ipLocation, ip: '', data: null })} className="" />
            </div>
            <Button type="primary" className="ml-5 rounded" loading={handleSearch.isLoading} onClick={() => handleSearch.mutate()}>
              搜索
            </Button>
            <Button className="rounded ml-2" onClick={() => setIpLocation({ ...ipLocation, ip: '', data: null })}>
              重置
            </Button>
          </div>
        </div>
        <Spin tip="数据更新中，请稍后。。。" size="small" spinning={handleSearch.isLoading}>
          <Descriptions title="" bordered items={items} className={`${handleSearch.isLoading ? 'mb-4' : ''} mt-4`} />
        </Spin>
      </Modal>
    </div>
  )
}